import { render } from "./downloadApp.vue?vue&type=template&id=6b24f45e&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"

import "./downloadApp.vue?vue&type=style&index=0&id=6b24f45e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b24f45e"]])

export default __exports__